// extracted by mini-css-extract-plugin
export default {"text":"ReadMoreExpand_text__FL7rz","actions":"ReadMoreExpand_actions__fhjcS"};